'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagRsAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0002 6.66667H0.00016276V13.3333H28.0002V6.66667Z",
          fill: "#17508F"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0L0.00016276 6.66667H28.0002L28 0Z", fill: "#E1444D" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0002 13.3333H0.00016276L0 20H28L28.0002 13.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.00016 10C6.00016 9.10157 6.4986 7.31284 6.4986 7.31284C6.59151 6.95597 6.9545 6.66667 7.32735 6.66667H10.0063C10.3711 6.66667 10.7433 6.95216 10.8351 7.30818C10.8351 7.30818 11.3335 9.08014 11.3335 10C11.3335 10.86 10.8316 12.6926 10.8316 12.6926C10.7406 13.0465 10.4739 13.5656 10.2235 13.8298C10.2235 13.8298 9.66683 14.6667 8.66683 14.6667C7.66683 14.6667 7.11018 13.8298 7.11018 13.8298C6.86533 13.5556 6.59035 13.0438 6.4986 12.6835C6.4986 12.6835 6.00016 10.8814 6.00016 10Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.2297 6.3963L5.06348 14.1041L6.10463 14.9371L12.2709 7.22923L11.2297 6.3963Z",
          fill: "#C43840"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.06348 7.22923L11.2297 14.9371L12.2709 14.1041L6.10463 6.3963L5.06348 7.22923Z",
          fill: "#C43840"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.66683 12C9.40321 12 10.0002 11.1046 10.0002 10C10.0002 8.89543 9.40321 8 8.66683 8C7.93045 8 7.3335 8.89543 7.3335 10C7.3335 11.1046 7.93045 12 8.66683 12Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66683 5.33333L6.00016 4L7.3335 4.66667L8.66683 4L10.0002 4.66667L11.3335 4L10.6668 5.33333V6C10.6668 6.36819 10.3792 6.66667 10.0063 6.66667H7.32735C6.96255 6.66667 6.66683 6.35742 6.66683 6V5.33333Z",
          fill: "#D1A43A"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 20V13.3161H0.5L0.5 19.5H27.5V13.3161H28V20H0Z", fill: "#949494" })
    ]
  }
);
const VpFlagRsAsset = forwardRef(FlagRsAsset);

export { VpFlagRsAsset as default };
